module.exports = __webpack_public_path__ + "static/media/favicon-144.8a8f6978.png";